/**
 * Outbound destinations, kept in one place because the same handful of URLs
 * appear across the header, hero, case data, final CTA and footer.
 */

/** Low-commitment entry point: the self-serve revenue projection tool. */
export const FORECAST_URL = 'https://admin.elitesportfinance.com/forecast';

/**
 * High-intent entry point.
 *
 * TODO: point this at the real scheduling link (Cal.com / Calendly) once it
 * exists. It routes to the contact form for now — previously this was a bare
 * `mailto:`, which is the weakest possible path for the page's most valuable
 * action: it dead-ends for anyone on webmail.
 */
export const BOOK_CALL_URL = 'https://admin.elitesportfinance.com/contact-us';

export const CONTACT_URL = 'https://admin.elitesportfinance.com/contact-us';
